import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { store } from './store';
import App from './App';
import './index.css';
import { initializeMonitoring } from './utils/monitoring/faro';
import { analytics } from './utils/analytics/AnalyticsService';

// Initialize Grafana Faro monitoring
initializeMonitoring();

// Initialize analytics
analytics.initialize().catch(console.error);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);
